import { Directive } from '@angular/core';

@Directive({
  selector: `ns-dialog-content`,
  host: { class: 'dialog-content' }
})
export class DialogContentDirective {}

@Directive({
  selector: `ns-dialog-actions`,
  host: { class: 'dialog-actions' }
})
export class DialogActionsDirective {}
